/**
 * Free gift
 * Automatically adds a configured gift product to the cart once the cart value
 * reaches a threshold, and removes it again if the cart drops below.
 *
 * The gift is priced at 0 kr by a Shopify automatic discount ("Buy X, get Y" /
 * amount off product at 100%) — this script only manages the line item.
 *
 * Config comes from window.theme.freeGift = { enabled, variantId, threshold }.
 * The gift line is tagged with the line item property `_free_gift` so it can be
 * identified and removed regardless of whether the same product is also bought
 * normally.
 */
(function () {
  const cfg = (window.theme && window.theme.freeGift) || {};
  if (!cfg.enabled || !cfg.variantId || !cfg.threshold) return;

  const GIFT_PROP = '_free_gift';
  const SECTIONS = [
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];
  const routes = (window.theme && window.theme.routes) || {};
  const sectionsParam = SECTIONS.map((s) => s.section).join(',');

  let busy = false;

  function getCart() {
    return fetch(`${routes.cart_url || '/cart'}.js`, {
      headers: { Accept: 'application/json' }
    }).then((r) => r.json());
  }

  function findGiftLine(cart) {
    return cart.items.find(
      (i) => i.properties && (i.properties[GIFT_PROP] || i.properties[GIFT_PROP] === 'true')
    );
  }

  // Value of everything except the gift itself (in cents).
  function eligibleTotal(cart) {
    return cart.items.reduce((sum, i) => {
      if (i.properties && i.properties[GIFT_PROP]) return sum;
      return sum + i.original_line_price;
    }, 0);
  }

  function addGift() {
    return fetch(`${routes.cart_add_url || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: cfg.variantId, quantity: 1, properties: { [GIFT_PROP]: 'true' } }],
        sections: sectionsParam,
        sections_url: window.location.pathname
      })
    }).then((r) => r.json());
  }

  function changeLine(key, quantity) {
    return fetch(`${routes.cart_change_url || '/cart/change'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: sectionsParam,
        sections_url: window.location.pathname
      })
    }).then((r) => r.json());
  }

  function getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : null;
  }

  function render(state) {
    if (!state || !state.sections) return;
    SECTIONS.forEach((s) => {
      const container = document.getElementById(s.id);
      if (!container || !state.sections[s.section]) return;
      const target = container.querySelector(s.selector) || container;
      const inner = getSectionInnerHTML(state.sections[s.section], s.selector);
      if (inner !== null) target.innerHTML = inner;
    });
    // Re-bind cart-page remove buttons if the Cart class is present
    if (typeof Cart !== 'undefined' && document.getElementById('Cart')) {
      try { new Cart().renderContents(state); } catch (e) { /* noop */ }
    }
    const drawer = document.getElementById('Cart-Drawer');
    if (drawer && typeof drawer.removeProductEvent === 'function') drawer.removeProductEvent();
  }

  function sync() {
    if (busy) return Promise.resolve();
    busy = true;
    return getCart()
      .then((cart) => {
        const giftLine = findGiftLine(cart);
        const total = eligibleTotal(cart);

        if (total >= cfg.threshold) {
          if (!giftLine) return addGift();
          if (giftLine.quantity !== 1) return changeLine(giftLine.key, 1);
        } else if (giftLine) {
          return changeLine(giftLine.key, 0);
        }
        return null;
      })
      .then((state) => { if (state) render(state); })
      .catch((e) => { console.error('[free-gift]', e); })
      .finally(() => { busy = false; });
  }

  // React to cart mutations. Our own render() does not dispatch these, so no loop.
  ['cart:item-added', 'line-item:change:end', 'cart:refresh'].forEach((ev) => {
    document.addEventListener(ev, function () { sync(); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
